import React, { useState } from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { Text1, Text4 } from '../../../styles';
import { alertify, handleApiExceptions, goTo } from '../../../app_methods';
import { BulkUploadBatch } from '../../../models';
import { MerchantService } from '../../../services';
import { BulkUploadForm, OTPModal } from '../../Common';
import { ErrorModal } from './error_modal';
import { BATCHTYPES, bulkOperationsTypeMaster } from './constants';
import { Icon, Select } from 'antd';
import { connect } from 'react-redux';
import { updateCurrentUserAction } from '../../../redux/actions';
import _ from 'lodash';


const batch = new BulkUploadBatch();

const BulkUploadModalComponent = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [showOTPModal, setShowOTPModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [validationErrors, setValidationErrors] = useState([]);
    const [uploadType, setUploadType] = useState(props.type)
    const virtual_accounts = props.current_user.virtual_accounts ?? []
    const [isBankOTP, setIsBankOTP] = useState(false);
    const [OTPReferenceKey, setOTPReferenceKey] = useState();
    const [batchData, setBatchData] = useState({});

    const validateBulkUpload = async (obj) => {
        setIsLoading(true);
        const is_process_and_validate = props?.type == "transfer" && obj?.continue_on_error;
        const apiCall = is_process_and_validate ? batch.validateAndProcess : batch.validate;

        // get the otp first authorization first, if by pass validation is enabled
        if(is_process_and_validate && props.type == "transfer" && !props.current_user.bpo) {
            toggleOTPModal();
            generateBulkUploadOTP();
            return;
        }

        const response = await apiCall({ key: props.current_user.key, batch_type: uploadType, continue_on_error:obj?.continue_on_error });
        if ([401, 500].includes(response.status)) {
            setIsLoading(false);
            handleApiExceptions(response.message);
            return
        }
        if (!response.success) {
            setIsLoading(false);
            if (typeof (response.message) == "string") {
                handleApiExceptions(response.message);
                return;
            }
            if (response.message) {
                setValidationErrors(response.message.errors);
                toggleErrorModal();
                return;
            }
        }
        setIsLoading(false);
        if (!obj?.continue_on_error && props.type == "transfer" && !props.current_user.bpo) {
            toggleOTPModal();
            generateBulkUploadOTP();
            return;
        }
        if (props.type == "transfer" && obj?.continue_on_error) {
            alertify(
                "Success",
                "Bulk Operation created successfully. It will be processed in about 30 minutes. You can check the status of this bulk operation under Bulk Operations section.",
                "confirm",
                {
                    closable: true,
                    cancelText: "Close",
                    okText: "Go to Bulk Operations",
                    onOk: () => goTo(`/batches/${uploadType}`, props.history),
                    onCancel: () => { },
                    icon: <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
                }
            );
            props.toggleBulkUploadModal()
            return;
        }
        processBatch(uploadType);
    };

    const generateBulkUploadOTP = (type="transfer") => {
        setIsLoading(true);
        let queryData = {type: type,
            name: batch.name,
            send_email: true,
            send_sms: true
        }
        if (props?.current_user?.merchant_active_on_sbi) {
                        const virtual_account =  virtual_accounts.find((va) =>va.virtual_account_number === batch.virtual_account_number) || {}
                        queryData['provider_code'] = virtual_account?.provider_code
                        MerchantService.generate_bank_otp(queryData).then((response) => {
                            if (response.success) {
                                setIsBankOTP(true)
                                setIsLoading(false);
                                setShowOTPModal(true);
                                setOTPReferenceKey(response.otp_ref_key)
                            }
                            else {
                                setIsLoading(false);
                                handleApiExceptions(response);
                            }
                        }).catch((error) => {
                            setIsLoading(false);
                            handleApiExceptions({ success: false, status: (error.response && error.response.status) || 400 });
                        });
                    } 
        else {MerchantService.generate_otp(queryData).then((response) => {
            if (response.success) {
                setIsLoading(false);
            }
            else {
                setIsLoading(false);
                handleApiExceptions("OTP generation failed.");
            }
        }).catch((error) => {
            setIsLoading(false);
            handleApiExceptions({ success: false, status: (error.response && error.response.status) || 400 });
        });}
    };

    const verifyOTP = (otp) => {
        setIsVerifying(true);
        if (!props?.current_user?.merchant_active_on_sbi){
        MerchantService.verify_otp({ otp }).then((response) => {
            if (response.success) {
                if (response.data.verified) {
                    toggleOTPModal();
                    // if by pass validation is enabled do no process
                    processBatch(uploadType);
                }
                else handleApiExceptions("OTP is incorrect.");
            }
            else handleApiExceptions("OTP verification failed.");
            setIsVerifying(false);
        }).catch((error) => {
            setIsVerifying(false);
            handleApiExceptions({ success: false, status: (error.response && error.response.status) || 400 });
        });
        }
        else{
            let otp_details = {'otp':otp, 'otp_ref_key': OTPReferenceKey}
            batch.otp_details = otp_details
            setIsVerifying(false);
            toggleOTPModal();
            process_bulk_on_bank({batch_type:uploadType, otp_details:otp_details});
        }
    };

    const process_bulk_on_bank = async(data)=>{
        setIsLoading(true);
        const response = await batch.process_bulk_on_bank({ key: props.current_user.key, batch_type:data?.batch_type, batch_id:batchData?.batch_id,otp_details:data?.otp_details})
        if (!response.success) {
            setIsLoading(false);
            handleApiExceptions(response?.message?.errors,"Something went wrong.");
            return;
        }
        alertify(
            "Success",
            "Bulk Operation created successfully. It will be processed in about 30 minutes. You can check the status of this bulk operation under Bulk Operations section.",
            "confirm",
            {
                closable: true,
                cancelText: "Close",
                okText: "Go to Bulk Operations",
                onOk: () => goTo(`/batches/${data?.batch_type}`, props.history),
                onCancel: () => { },
                icon: <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
            }
        );
        setIsLoading(false);
        props.toggleBulkUploadModal();
        props.onSuccess();
    }

    const processBatch = async (batch_type, con) => {
        setIsLoading(true);
        let response = {}
        if(batch_type == "transfer" && batch.continue_on_error) {
            response = await batch.validateAndProcess({
                batch_type: batch_type,
                key: props.current_user.key,
                continue_on_error: batch?.continue_on_error
            });
        } else {
            response = await batch.process({ key: props.current_user.key });
        }
        if (!response.success) {
            setIsLoading(false);
            handleApiExceptions(response?.message?.errors,"Something went wrong.");
            // Work on display or error !
            return;
        }
        if (batchData?.collect_otp) {
            generateBulkUploadOTP(batch_type)
        }
        else{
        alertify(
            "Success",
            "Bulk Operation created successfully. It will be processed in about 30 minutes. You can check the status of this bulk operation under Bulk Operations section.",
            "confirm",
            {
                closable: true,
                cancelText: "Close",
                okText: "Go to Bulk Operations",
                onOk: () => goTo(`/batches/${batch_type}`, props.history),
                onCancel: () => { },
                icon: <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
            }
        );
        setIsLoading(false);
        props.toggleBulkUploadModal();
        props.onSuccess();
    }
    };

    const toggleOTPModal = () => {
        setShowOTPModal(!showOTPModal);
    };

    const toggleErrorModal = () => {
        setShowErrorModal(!showErrorModal);
    };

    const handleOnCancel = () => {
        setUploadType(props.type) 
        props.toggleBulkUploadModal()
    }


    return (
        <EaseModal
            width={350}
            title={false}
            visible={props.visible}
            onCancel={handleOnCancel}
            centered
            hideFooter
            destroyOnClose
        >
            <Text1 className="d-block mb-2" strong>{bulkOperationsTypeMaster[props.type]}</Text1>
            <BulkUploadForm
                onSubmit={(values) => {
                    batch.set(values);
                    validateBulkUpload({"continue_on_error":values?.continue_on_error});
                }}
                loading={isLoading}
                submitText="Upload"
                batch_type={uploadType}
                merchant={props.current_user}
                bulkUploadModalType={props.bulkUploadModalType}
                setUploadType={setUploadType}
                uploadType={uploadType}
                showBatchType={props.showBatchType}
                type={props.type}
            />
            <ErrorModal
                visible={showErrorModal}
                toggleErrorModal={toggleErrorModal}
                errors={validationErrors}
            />
            <OTPModal
                visible={showOTPModal}
                onCancel={toggleOTPModal}
                verifyOTP={verifyOTP}
                loading={isVerifying}
                generateOTP={generateBulkUploadOTP}
                isBankOTP={isBankOTP}
            />
        </EaseModal>
    )
};

BulkUploadModalComponent.defaultProps = {
    bulkUploadModalType: '',
    type:'',
    showBatchType:false,
}

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
})

const BulkUploadModal = connect(mapStateToProps, mapDispatchToProps)(BulkUploadModalComponent);
export { BulkUploadModal };